export default __webpack_public_path__ + "static/media/Icon feather-arrow-right-circle-white.617d47d1.svg";